<app-si-dialog [hideHeader]="true" #dialogComponent modalFooterClasses="si-dialog__footer--centered">
  <ng-template appDialogBody>
    <div class="px-16 py-8">
      <div class="flex items-center gap-5">
        <fa-icon class="text-primary-light shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
        <p *ngIf="data?.message && !data?.messageTemplate" class="mb-0">{{ data?.message }}</p>
        <ng-container
            *ngIf="data?.messageTemplate"
            [ngTemplateOutlet]="data?.messageTemplate"></ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template appDialogFooter>
    <button matButton="outlined" (click)="dialogComponent.onCloseDialog(false)" *ngIf="showCancelBtn">Cancel</button>
    <button matButton="filled" (click)="dialogComponent.onCloseDialog(true)">{{ submitBtnText }}</button>
  </ng-template>
</app-si-dialog>
